export default __webpack_public_path__ + "static/media/cre.ee46ea55.svg";